const CLASS_ORDER_BUTTON = '.order-button';
const CLASS_BONUS_PRICE_TITLE = '.bonus__title';
const CLASS_BONUS_PRICE_NETTO = '.bonus__price--netto';
const CLASS_BONUS_PRICE_MWST = '.bonus__price--mwst';

const CLASS_PRODUCT_PRICE_TITLE = '.product__title';
const CLASS_PRODUCT_PRICE_NETTO = '.product__price--netto';
const CLASS_PRODUCT_PRICE_MWST = '.product__price--mwst';
const CLASS_PRICE_SUMMARY = '.price--summary';

const CLASS_SUMMARY_PRODUCT_TITLE = '.summary__product--title';
const CLASS_SUMMARY_PRODUCT_PRICE = '.summary__product--price';
const CLASS_SUMMARY_BONUS_TITLE = '.summary__bonus--title';
const CLASS_SUMMARY_BONUS_PRICE = '.summary__bonus--price';

let priceProduct;
let priceBonus;
let bonusData;



export default class ModelAjax{
    
    constructor(){
        
    }

    getData(id, type, offerId = false) {

        let action;
        let obj;
        let modelType;
     
        switch(type){
            case 'product': modelType = 'product'; action = 'getProduct';  obj = model_data_product; break;
            case 'bonus': modelType = 'bonus'; action = 'getBonus'; obj = model_data_bonus; break;
        }
      
        let data = {
            action: action,
            modelId: id,
            nonce: obj.nonce
        };

        if(offerId){
            data.offerId = offerId;
        }

        fetch(obj.ajaxurl+'?action='+obj.action, { 
            method: "POST",
            headers: { 
                "Content-Type": "application/json; charset=utf-8" 
            },
            credentials: 'same-origin',
            body : JSON.stringify(data)
        })
        .then(res => res.json()) // parse response as JSON (can be res.text() for plain response)
        .then(response => {
            this.patchPrice(response, modelType);
        })
        .catch(err => {
            console.log(err);
        });
    
    }

    getDataById(type, id){

        let action;
        let obj;
        let modelType;
     

        switch(type){
            case 'product': modelType = 'product'; action = 'getProductById';  obj = model_data_product; break;
            case 'bonus': modelType = 'bonus'; action = 'getBonusById'; obj = model_data_bonus; break;
        }

        let data = {
            action: action,
            modelId: id,
            nonce: obj.nonce
        };
       
        return fetch(obj.ajaxurl+'?action='+action, { 
            method: "POST",
            headers: { 
                "Content-Type": "application/json; charset=utf-8" 
            },
            credentials: 'same-origin',
            body : JSON.stringify(data)
        })
        .then(res => res.json()) // parse response as JSON (can be res.text() for plain response)
        .catch(err => {
            console.log(err);
        });

    }

    getDataByMetaIds(id, type, offerId = false) {
        let action;
        let obj;
        let modelType;

        switch(type){
            case 'product': modelType = 'product'; action = 'getProductByMetaId';  obj = model_data_product; break;
            case 'bonus': modelType = 'bonus'; action = 'getBonusByMetaId'; obj = model_data_bonus; break;
        }
      
        let data = {
            action: action,
            modelId: id,
            nonce: obj.nonce
        };

        if(offerId){
            data.offerId = offerId;
        }

        fetch(obj.ajaxurl+'?action='+data.action, { 
            method: "POST",
            headers: { 
                "Content-Type": "application/json; charset=utf-8" 
            },
            credentials: 'same-origin',
            body : JSON.stringify(data)
        })
        .then(res => res.json()) // parse response as JSON (can be res.text() for plain response)
        .then(response => {
            this.patchPrice(response, modelType, true);
            this.patchOrder(response, modelType);
        })
        .catch(err => {
            console.log(err);
        });
    
    }

    findGetParameter(parameterName) {
        let result = null,
            tmp = [];
        location.search
            .substr(1)
            .split("&")
            .forEach(function (item) {
              tmp = item.split("=");
              if (tmp[0] === parameterName) result = decodeURIComponent(tmp[1]);
            });
        return result;
    }

    patchOrder(data, type){
        let euroFormat = new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }); 
        let mwst;
        let mwstPrice;
        let titleEl;
        let mwstEl;
        let nettoEl;
        let priceBrutto;
        
        switch(type){
            case 'product': 
                priceProduct = data.price_brutto.replace(/,/g, '.');
                mwst = 7;
                titleEl = document.querySelector(CLASS_SUMMARY_PRODUCT_TITLE)
                nettoEl = document.querySelector(CLASS_SUMMARY_PRODUCT_PRICE);
                priceBrutto = priceProduct;
                break;
            case 'bonus': 
                priceBonus = data.price_brutto.replace(/,/g, '.');
                priceBrutto = priceBonus;
                mwst = 19;
                titleEl = document.querySelector(CLASS_SUMMARY_BONUS_TITLE)
                nettoEl = document.querySelector(CLASS_SUMMARY_BONUS_PRICE);

                break;
        }

        mwstPrice = ((Number(priceBrutto) * Number(mwst))/100);
        titleEl.innerHTML = data.title;
        nettoEl.innerHTML = euroFormat.format((Number(priceBrutto) - Number(mwstPrice)));

        if(typeof priceBonus != 'undefined'){
            document.querySelector(CLASS_PRICE_SUMMARY).innerHTML = euroFormat.format((Number(priceProduct) + Number(priceBonus)));
        }else{
            document.querySelector(CLASS_PRICE_SUMMARY).innerHTML = euroFormat.format(Number(priceBrutto));
        }
    }

    patchPrice(data, type, patchOrder = false){
 
        let euroFormat = new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }); 
        let mwst;
        let mwstPrice;
        let titleEl;
        let mwstEl;
        let nettoEl;
        let priceBrutto;
        
        switch(type){
            case 'product': 
                priceProduct = data.price_brutto.replace(/,/g, '.');
                mwst = 7;
                titleEl = document.querySelector(CLASS_PRODUCT_PRICE_TITLE)
                mwstEl = document.querySelector(CLASS_PRODUCT_PRICE_MWST)
                nettoEl = document.querySelector(CLASS_PRODUCT_PRICE_NETTO);
                priceBrutto = priceProduct;
                break;
            case 'bonus': 
                priceBonus = data.price_brutto.replace(/,/g, '.');
                priceBrutto = priceBonus;
                mwst = 19;
                titleEl = document.querySelector(CLASS_BONUS_PRICE_TITLE)
                mwstEl = document.querySelector(CLASS_BONUS_PRICE_MWST)
                nettoEl = document.querySelector(CLASS_BONUS_PRICE_NETTO);
                break;
        }

        mwstPrice = ((Number(priceBrutto) * Number(mwst))/(100 + Number(mwst)));
        titleEl.innerHTML = data.title;
        mwstEl.innerHTML = euroFormat.format((mwstPrice));
        nettoEl.innerHTML = euroFormat.format((Number(priceBrutto) - Number(mwstPrice)));


        if(typeof priceBonus != 'undefined'){
            
            document.querySelector(CLASS_PRICE_SUMMARY).innerHTML = euroFormat.format((Number(priceProduct) + Number(priceBonus)));
        }else{
            document.querySelector(CLASS_PRICE_SUMMARY).innerHTML = euroFormat.format(Number(priceBrutto));
        }
    }

}


